// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-account-modal {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.delete-account-modal .delete-account-warning > p {
  margin-block: 4px;
}
.delete-account-modal .delete-account-footer {
  display: flex;
  justify-content: space-between;
}
.delete-account-modal .delete-account-footer .delete-account-actions {
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboards/SupportDashboard/UserInformation/DeleteAccountModal/DeleteAccountModal.less"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AADD;AAFA;EAME,iBAAA;AADF;AALA;EAUE,aAAA;EACA,8BAAA;AAFF;AATA;EAcG,aAAA;EACA,QAAA;AAFH","sourcesContent":["@import (reference) \"../../../../../Styles/colors\";\n\n.delete-account-modal {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\n\t.delete-account-warning > p {\n\t\tmargin-block: 4px;\n\t}\n\n\t.delete-account-footer {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\n\t\t.delete-account-actions {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
